import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookMessenger } from "@fortawesome/free-brands-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

/**
 * FloatingMessenger - Floating action button for Messenger contact
 * Appears after scrolling past hero section
 * Includes tooltip on first appearance
 */
function FloatingMessenger() {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipDismissed, setTooltipDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling 300px
      const shouldShow = window.scrollY > 300;
      setIsVisible(shouldShow);
      
      // Show tooltip briefly when first visible (only once)
      if (shouldShow && !tooltipDismissed && !showTooltip) {
        setShowTooltip(true);
        // Auto-hide tooltip after 5 seconds
        setTimeout(() => {
          setShowTooltip(false);
        }, 5000);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [tooltipDismissed, showTooltip]);

  const dismissTooltip = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowTooltip(false);
    setTooltipDismissed(true);
  };

  const buttonStyles = {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #0084ff 0%, #0066cc 100%)',
    color: 'white',
    border: 'none',
    boxShadow: '0 4px 20px rgba(0, 132, 255, 0.4)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.75rem',
    zIndex: 1000,
    transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
    transform: isVisible ? 'scale(1)' : 'scale(0)',
    opacity: isVisible ? 1 : 0,
  };

  const tooltipStyles = {
    position: 'fixed',
    bottom: '92px',
    right: '24px',
    background: 'white',
    color: '#333',
    padding: '12px 16px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    fontSize: '0.9rem',
    fontWeight: 500,
    maxWidth: '200px',
    zIndex: 1001,
    transition: 'all 0.3s ease',
    transform: showTooltip ? 'translateY(0)' : 'translateY(10px)',
    opacity: showTooltip ? 1 : 0,
    pointerEvents: showTooltip ? 'auto' : 'none',
  };

  const tooltipArrowStyles = {
    position: 'absolute',
    bottom: '-8px',
    right: '26px',
    width: '0',
    height: '0',
    borderLeft: '8px solid transparent',
    borderRight: '8px solid transparent',
    borderTop: '8px solid white',
  };

  const closeButtonStyles = {
    position: 'absolute',
    top: '-6px',
    right: '-6px',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    background: '#e0e0e0',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.65rem',
    color: '#666',
  };

  return (
    <>
      {/* Tooltip */}
      <div style={tooltipStyles}>
        <button 
          style={closeButtonStyles}
          onClick={dismissTooltip}
          aria-label="Cerrar"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
        ¿Prefieres escribirnos? ¡Estamos en Messenger!
        <div style={tooltipArrowStyles}></div>
      </div>

      {/* Floating Button */}
      <a
        href="https://m.me/293435430831934"
        target="_blank"
        rel="noopener noreferrer"
        style={buttonStyles}
        aria-label="Contactar por Messenger"
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.boxShadow = '0 6px 28px rgba(0, 132, 255, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = isVisible ? 'scale(1)' : 'scale(0)';
          e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 132, 255, 0.4)';
        }}
      >
        <FontAwesomeIcon icon={faFacebookMessenger} />
      </a>
    </>
  );
}

export default FloatingMessenger;
